<template>
  <div id="app" class="vue-plugin-wrapper" :style="{ '--main-color': mainColor }">

    <div class="border d-block d-md-block d-lg-block">
      <div class="row mx-4 mb-5  d-none d-md-flex d-lg-flex twoqbsAllFilters">
        <!-- <div class="col-md-2 col-lg-2">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">

            <div class="twoqbsTypeFilter">
              <button @click="showTypeFilters = !showTypeFilters" class="btn btn-outline-dark twoqbsStageButton">
                Rodzaj lokalu
              </button>

              <div v-show="showTypeFilters" class="twoqbsTypeCheckboxList text-start text-nowrap">
                <div v-for="(item, index) in typeOf" :key="index">
                  <input @change="filterdTable(price, rooms, area, isAvailable, checkedTypes)" type="checkbox"
                    :id="item" v-model="checkedTypes" :value="item" />
                  <label :for="item">
                    <span>&nbsp;</span>{{ item }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-12 col-lg-3 range-slider">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <span @click="sortBy('price')" class="btn btn-outline-dark twoqbsStageButton">Wybierz <br> cenę 
              <!-- <span
                v-if="sortKey === 'price'">
                <span v-if="sortAsc"> ↑</span>
                <span v-else> ↓</span>
              </span><span v-else> ↑↓</span> -->
            
            </span>
          </div>
          <div class="d-flex justify-content-center">
            <vue-range-slider ref="slider" width="80%" v-model="price"
              @input="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" :min="minPrice" :max="maxPrice"
              :formatter="numberWithSpaces" :step="10000">

            </vue-range-slider>
          </div>
        </div>
        <div class="col-md-12 col-lg-3 range-slider">
          <!-- <div class="mb-4" style="text-align: left">Cena</div>
          <vue-range-slider
            ref="slider"
            width="100%"
            v-model="price"
            @input="filterdTable(price, area, isAvailable)"
            :min="minPrice"
            :max="maxPrice"
            :step="10000"
          >
          </vue-range-slider> -->
          <!-- </div> -->
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 1rem">
            <span @click="sortBy('rooms')" class="btn btn-outline-dark twoqbsStageButton">Wybierz <br> liczbę pokoi
              
              <!-- <span
                v-if="sortKey === 'rooms'">
                <span v-if="sortAsc"> ↑</span>
                <span v-else> ↓</span>
              </span><span v-else> ↑↓</span> -->
            
            </span>
          </div>
          <div class="room-checkboxes d-flex justify-content-center gap-3">
            <label class="btn btn-outline-dark" :class="{ active: selectedRooms.includes(4) }">
              <input type="checkbox" v-model="selectedRooms" :value="4" 
                     @change="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" 
                     style="display: none;">
              4 
            </label>
            <label class="btn btn-outline-dark" :class="{ active: selectedRooms.includes(5) }">
              <input type="checkbox" v-model="selectedRooms" :value="5" 
                     @change="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" 
                     style="display: none;">
              5 
            </label>
          </div>
        </div>
        <div class="col-md-12 col-lg-3 range-slider">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <span @click="sortBy('area')" class="btn btn-outline-dark twoqbsStageButton">Wybierz <br> powierzchnię 
              <!-- <span
                v-if="sortKey === 'area'">
                <span v-if="sortAsc"> ↑</span>
                <span v-else> ↓</span>
              </span><span v-else> ↑↓</span> -->
            </span>
          </div>
          <div class="d-flex justify-content-center">
            <vue-range-slider ref="slider" width="80%" v-model="area"
              @input="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" :min="minArea" :max="maxArea"
              :step="5">
            </vue-range-slider>
          </div>
        </div>

        <!-- <div class="col-md-12 col-lg-2">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <label class="btn btn-outline-dark twoqbsStageButton">
              <input type="checkbox" v-model="isAvailable"
                @change="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" />
              Tylko dostępne
            </label>

          </div>
        </div> -->

        <div class="col-md-12 col-lg-3">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <!-- <button class="btn btn-outline-dark" @click="showModal(selectedFlats)">Zapytaj o ofertę
              <span v-if="selectedFlats.length > 0">({{ selectedFlats.length }})</span></button> -->
      <a href="/prospekty" target="_blank" rel="noopener"
                 
       class="btn btn-outline-dark twoqbsStageButton " >
                    Prospekt <br> informacyjny
            </a>
          </div>

        </div>
      </div>

      <div class="row" style="max-width: 98%">

        <table class="
            twoqbsxml-table
            table
            d-none d-md-table d-lg-table
            mx-4
            my-4
          ">

          <thead class="twoqbsxml-thead">
            <th scope="col" class="twoqbsxml-th">Numer <br>domu</th>
          <th scope="col" class="twoqbsxml-th" @click="sortBy('rooms')" style="cursor: pointer">Liczba <br> pokoi<span
                v-if="sortKey === 'rooms'">
                <span v-if="sortAsc">↑</span>
                <span v-else>↓</span>
              </span></th>
            <th scope="col" class="twoqbsxml-th" @click="sortBy('area')" style="cursor: pointer">Powierzchnia
              <br>użytkowa<span v-if="sortKey === 'area'">
                <span v-if="sortAsc">↑</span>
                <span v-else>↓</span>
              </span>
            </th>
            <th scope="col" class="twoqbsxml-th">Cena za<span>m<sup>2</sup></span>brutto <br>(pow. użytkowa)</th>
            <th scope="col" class="twoqbsxml-th">Powierzchnia<br>sprzedażowa</th>
            <th scope="col" class="twoqbsxml-th">Cena za<span>m<sup>2</sup></span>brutto <br>(pow. sprzedażowa)</th>
            <th scope="col" class="twoqbsxml-th">Miejsca <br> postojowe <br>w cenie</th>
            <th scope="col" class="twoqbsxml-th">Ogród</th>
            <th scope="col" class="twoqbsxml-th">W cenie</th>
            <th scope="col" class="twoqbsxml-th" @click="sortBy('price')" style="cursor: pointer">Cena <br>nieruchomości<span
                v-if="sortKey === 'price'">
                <span v-if="sortAsc">↑</span>
                <span v-else>↓</span>
              </span></th>
            <th scope="col" class="twoqbsxml-th">Status</th>
            <th colspan="2" class="twoqbsxml-th">Pobierz <br>materiały</th>
            <th></th>


          </thead>
          <tbody>
            <tr v-if="sortedFlats.length === 0">
              <td colspan="12"><span style="color:red;">{{ sortedFlats.length === 0 ? 'Brak lokali spełniających kryteria' : '' }}</span></td>
            </tr>
            <template v-for="item in sortedFlats" >
              <!-- wiersz główny -->
              <tr class="twoqbsxml-tr" :key="item.id" :id="item.local_number">

                <!-- <tr class="twoqbsxml-tr" v-for="item in sortedFlats" :key="item.id" :id="item.local_number"> -->
                <td class="twoqbsxml-td twoqbsxml-local-name">
                  {{ item.local_number }}
  <div v-if="item.stage && item.stage !== '' && !Array.isArray(item.stage)" 
       style="font-size: 0.75em; color: #999; margin-top: 2px; font-style: italic;">
    {{ item.stage }}
  </div>
                </td>
                <td class="twoqbsxml-td twoqbsxml-scrolling-cell">
                  <div class="scrolling-text">{{ item.rooms }}</div>
                </td>
                <td class="twoqbsxml-td">
                  <span v-if="(item.area && item.area > 0) || (item.area_usable && item.area_usable > 0)">
                    {{ item.area && item.area > 0 ? item.area : item.area_usable }}m<sup>2</sup>
                  </span>
                  <span v-else>-</span>
                  <!-- <tooltip-modal v-if=hasAdditionalAreas(item)>
                    <template #default><contiguity-list-simple :item="item" /></template>
                    <template #icon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 
             1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 
             0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                      </svg></template>
                  </tooltip-modal> -->
                </td>
                <td class="twoqbsxml-td">
                  <span>{{ numberWithSpaces(item.pricemkw)  }} zł
                   </span>
                </td>
                <td class="twoqbsxml-td">
                    <span>
                    {{item.area_usable }}m<sup>2</sup>
                  </span>
                 
                </td>
                <td class="twoqbsxml-td">
                  <span >{{ numberWithSpaces(item.pricemkw_usable) }} zł</span>
                
                </td>
                <td class="twoqbsxml-td">
                  <span v-if="item.number_of_mandatory_parking_spaces.length">{{ item.number_of_mandatory_parking_spaces }}</span>
                </td>
                <td class="twoqbsxml-td">
                 <span>{{ item.ogrod }}m<sup>2</sup></span>
                </td>
                <td class="twoqbsxml-td">
                     <contiguity-list-simple :item="item" />
                </td>
                <td class="twoqbsxml-td">
                  <span
                    v-if="item.promotion == 1 && isPromotionActive(item)"
                    style="font-weight:900;">{{ numberWithSpaces(item.promotion_price) }} zł<br><span
                      style="text-decoration: line-through; font-size:13px; font-weight: 300;">{{
                        numberWithSpaces(item.price) }}
                      zł</span></span>
                  <span
                    v-if="item.promotion == 1 && !isPromotionActive(item)"
                    style="color:green">{{ numberWithSpaces(item.price) }}</span>
                  <span v-if="item.promotion == 0">{{ numberWithSpaces(item.price) }} zł</span>
                  <!-- <span data-toggle="tooltip" data-placement="top" :title="item.name" :data-bs-delay='{"show":0,"hide":0}' data-bs-animation="false">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-info-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path
                        d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                    </svg>
                  </span> -->
                  <!-- {{ Number(item.minimal_price_gross)}} -->
                  <tooltip-modal v-if="Number(item.minimal_price_gross) >= 1">
                    <template #default><span>Ostatnia najniższa cena z 30 dni <br />
                        {{ (numberWithSpaces(item.minimal_price_gross) + ' zł' || '-') }}</span></template>
                    <template #icon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 
             1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 
             0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                      </svg></template>
                  </tooltip-modal>
                </td>
                <td class="twoqbsxml-td">
                  <!-- <span v-if="item.status_name == 'Dostępne'" style="color:green;">{{
                  item.status_name
                }}</span> -->
                  <span v-if="item.status_name == 'Dostępne' && item.promotion == 0" style="color:green;">{{
                    item.status_name
                  }}</span>
                  <span
                    v-if="item.promotion == 1 && isPromotionActive(item) && item.status_name == 'Dostępne'"
                    style="font-weight:900; color:green">Promocja</span>
                  <span
                    v-if="item.promotion == 1 && !isPromotionActive(item) && item.status_name == 'Dostępne'"
                    style="color:green">Dostępne</span>
                  <span v-if="
                    item.status_name == 'Rezerwacja ustna' ||
                    item.status_name == 'Umowa rezerwacyjna'
                  " style="color: orange">Rezerwacja</span>

                  <span v-if="
                    item.status_name == 'Umowa końcowa' ||
                    item.status_name == 'Umowa deweloperska' ||
                    item.status_name == 'Umowa przedwstępna'
                  " style="color: red">Sprzedany</span>
                </td>
                <!-- <td class="twoqbsxml-td">{{ item.stage }}</td> -->
                <td class="twoqbsxml-td twoqbsxml-download-element twoqbsxml-document-link">
                  <!-- <a v-if="item.document_link" style="text-decoration: none; color: black"
                    v-bind:href="item.document_link" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                      height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                      <path
                        d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                      <path
                        d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                    </svg></a> -->
                  <!-- Rzut -->
                  <tooltip-modal v-if="item.document_link">
                    <template #default>
                      <span>Zobacz Rzut</span>
                    </template>
                    <template #icon>
                      <a :href="item.document_link" target="_blank" style="text-decoration: none; color: black">
                        <img src="@/assets/plan.png" alt="Plan" width="32" height="32" />
                      </a>
                    </template>
                  </tooltip-modal>
                  <!-- Rzut 3D parter - wyświetl zawsze gdy jest element -->
                  <tooltip-modal v-if="item.plan3d_link && (typeof item.plan3d_link === 'string' || (Array.isArray(item.plan3d_link) && item.plan3d_link.length > 0))">
                    <template #default>
                      <span>Zobacz Rzut 3D parter</span>
                    </template>
                    <template #icon>
                      <a :href="item.plan3d_link.length === 1 ? item.plan3d_link[0] : item.plan3d_link[1]" target="_blank" style="text-decoration: none; color: black">
                        <img src="@/assets/3d.png" alt="Plan 3D parter" width="32" height="32" />
                      </a>
                    </template>
                  </tooltip-modal>
                  <!-- Rzut 3D piętro - wyświetl tylko gdy są 2 elementy -->
                  <tooltip-modal v-if="Array.isArray(item.plan3d_link) && item.plan3d_link.length === 2">
                    <template #default>
                      <span>Zobacz Rzut 3D piętro</span>
                    </template>
                    <template #icon>
                      <a :href="item.plan3d_link[0]" target="_blank" style="text-decoration: none; color: black">
                        <img src="@/assets/3d.png" alt="Plan 3D piętro" width="32" height="32" />
                      </a>
                    </template>
                  </tooltip-modal>
                </td>
                <td class="twoqbsxml-td twoqbsxml-download-element twoqbsxml-virtual-walk">
                  <!-- <a v-if="item.virtual_walk.length > 0" style="text-decoration: none; color: black"
                    v-bind:href="item.virtual_walk" target="_blank" title="Wirtualny spacer"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                      height="16" fill="currentColor" class="bi bi-dpad" viewBox="0 0 16 16">
                      <path
                        d="m7.788 2.34-.799 1.278A.25.25 0 0 0 7.201 4h1.598a.25.25 0 0 0 .212-.382l-.799-1.279a.25.25 0 0 0-.424 0Zm0 11.32-.799-1.277A.25.25 0 0 1 7.201 12h1.598a.25.25 0 0 1 .212.383l-.799 1.278a.25.25 0 0 1-.424 0ZM3.617 9.01 2.34 8.213a.25.25 0 0 1 0-.424l1.278-.799A.25.25 0 0 1 4 7.201V8.8a.25.25 0 0 1-.383.212Zm10.043-.798-1.277.799A.25.25 0 0 1 12 8.799V7.2a.25.25 0 0 1 .383-.212l1.278.799a.25.25 0 0 1 0 .424Z" />
                      <path
                        d="M6.5 0A1.5 1.5 0 0 0 5 1.5v3a.5.5 0 0 1-.5.5h-3A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 6.5 16h3a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 16 9.5v-3A1.5 1.5 0 0 0 14.5 5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 9.5 0zM6 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 11.5 6h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a1.5 1.5 0 0 0-1.5 1.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 4.5 10h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 6 4.5z" />
                    </svg></a> -->
                  <tooltip-modal v-if="item.virtual_walk.length > 0">
                    <template #default>
                      <span>Wirtualny spacer</span>
                    </template>
                    <template #icon>
                      <a :href="item.virtual_walk" target="_blank" style="text-decoration: none; color: black">
                        <img src="@/assets/3d.png" alt="3d" width="32" height="32" />
                      </a>
                    </template>
                  </tooltip-modal>
                </td>
                <!-- <td class="twoqbsxml-td twoqbsxml-download-element twoqbsxml-view360">
                  <tooltip-modal v-if="item.view360.length > 0" style="margin-left: 10px;">
                    <template #default>
                      <span>Widok 360°</span>
                    </template>
                    <template #icon>
                      <a :href="item.view360" target="_blank" style="text-decoration: none; color: black;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-globe" viewBox="0 0 16 16">
                          <path
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
                        </svg>
                      </a>
                    </template>
                  </tooltip-modal>
                   <a v-if="item.view360.length > 0" style="text-decoration: none; color: black"
                    v-bind:href="item.view360" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                      height="16" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                      <path
                        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
                    </svg></a> 

                </td> -->
                <td class="twoqbsxml-td">
                  <!-- <input type="checkbox" :value="item.local_number" v-model="selectedFlats" /> -->
                  <div class="button-stack">
                    <button class="btn btn-outline-dark twoqbsWawreButton" @click.prevent="showModal(item.local_number)">Zapytaj o ofertę</button>
                    <button class="btn btn-outline-dark btn-sm twoqbsStageButton" @click="toggleRow(item.id)">
                      {{ expandedRows.includes(item.id) ? "Zwiń" : "Zobacz więcej" }}
                    </button>
                  </div>
                </td>
                <!-- <td class="twoqbsxml-td"> -->
                  <!-- <a v-if="investmentInfo.informative_prospectus_link1" class="btn btn-outline-dark"
                    :href="investmentInfo.informative_prospectus_link1" target="_blank" rel="noopener" download>
                    Prospekt informacyjny
                  </a>
                  <span v-else class="btn btn-outline-dark disabled">Prospekt informacyjny</span> -->
                  <!-- <a v-if="getProspectLink(item.stage)" class="btn btn-outline-dark" :href="getProspectLink(item.stage)"
                    target="_blank" rel="noopener" download>
                    Prospekt informacyjny
                  </a> -->
                  <!-- <span v-else class="btn btn-outline-dark disabled">Prospekt informacyjny</span> -->
                <!-- </td> -->
              </tr>
              <tr v-if="expandedRows.includes(item.id)" :key="item.id">

                <td colspan="14" class="twoqbsxml-td expanded-row">
                  <div class="row">
                    <div class="col-6">
                 <div class="twoqbsxml-expanded-additional-field" v-if="pluginSettings.additional_field">
                        <h5>Dodatkowe informacje:</h5>
                         <div v-html="pluginSettings.additional_field"></div>
                        <!-- <p>{{ pluginSettings.additional_field }}</p> -->
                            </div> 
                      </div>
                    <div class="col-6">
                      <div>
                      <price-history :flat-id="item.id" />
                     
                 
                      <div class="twoqbsxml-expanded-additional-field mt-4" v-if="item.monetary_benefits">
                        <h5>Inne świadczenia pieniężne: {{ item.monetary_benefits }}</h5>
                          <div v-html="item.monetary_benefits"></div>
</div></div>    
                    </div>
                  </div>
                </td>

              </tr>
            </template>
            <!-- <td class="twoqbsxml-td twoqbsxml-ask">
                <span class="ask-button" @click="showModal(item)" v-if="item.ask_for_price == 1"> Zapytaj</span> -->
            <!-- <span @click="showModal(item)"
                  v-if="item.price && item.ask_for_price != 1 && item.promotion == 0 && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna') && item.local_number != '2.ZB2.B1' && item.local_number != '2.ZB6.B2'">{{
                    numberWithSpaces(item.price) }} zł</span>
                <span @click="showModal(item)"
                  v-if="item.price && item.ask_for_price != 1 && item.promotion == 1 && !(item.promotion_date_to > today && item.promotion_date_from <= today) && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna') && item.local_number != '2.ZB2.B1' && item.local_number != '2.ZB6.B2'">{{
                    numberWithSpaces(item.price) }} zł</span>
                <span @click="showModal(item)"
                  v-else-if="item.price && item.ask_for_price != 1 && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna') && (item.local_number == '2.ZB2.B1' || item.local_number == '2.ZB6.B2')">
                  {{ numberWithSpaces(item.promotion_price) }} zł</span> -->
            <!-- <span @click="showModal(item)" v-if="item.price && item.ask_for_price != 1 && item.promotion == 0 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna')" >{{ numberWithSpaces(item.price) }} zł</span> -->
            <!-- <span class="td-promotion-price" @click="showModal(item)"
                  v-else-if="item.price >= 1 && item.ask_for_price != 1 && item.promotion == 1 && (item.promotion_date_to > today && item.promotion_date_from <= today)">{{
                    numberWithSpaces(item.promotion_price) }} zł</span>
                <span
                  v-if="(!item.price || item.status_name == 'Wstrzymane' || item.status_name == 'Rezerwacja ustna') && item.ask_for_price != 1">-</span>
                <span v-if="(
                  item.status_name == 'Umowa rezerwacyjna' ||
                  item.status_name == 'Umowa deweloperska' ||
                  item.status_name == 'Umowa przedwstępna' ||
                  item.status_name == 'Wstrzymane' ||
                  item.status_name == 'Rezerwacja ustna')"></span>
              </td>
              <td class="twoqbsxml-td twoqbsxml-download-element"
                v-if="item.price && item.ask_for_price != 1 && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna')">
                <button class="btn btn-sm ZapytajButton" type="button" onclick="location.href='#kontakt'">Zapytaj o
                  rabat</button></td> -->
            <!-- <td   class="twoqbsxml-td twoqbsxml-download-element"  v-if="item.price && item.ask_for_price != 1 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna') && (item.local_number == '2.ZB2.B1' || item.local_number == '2.ZB6.B2') "><button class="btn btn-sm PromocjaButton" type="button" onclick="location.href='#kontakt'">PROMOCJA</button></td>
          -->
            <!-- <td v-else></td> -->


          </tbody>
        </table>
      </div>
    </div>
    <!--koniec wersji desktopowej-->
    <!-- Wersja mobilna  -->
    <div class="d-block d-sm-block d-md-none my-3">
      <div class="d-block d-md-none mx-auto">
        <button class="btn btn-outline-dark w-100 mb-3" @click="showMobileFilters = true">
          <span v-if="sortedFlats.length === 0" style="color:red;">Brak lokali spełniających kryteria</span>
          <span v-else>Pokaż filtry </span>
        </button>
        <div v-if="showMobileFilters" class="mobile-filters-overlay">
          <div class="mobile-filters-panel">
            <button class="btn-close" @click="showMobileFilters = false">×</button>
            
            <!-- Filtry w dwóch kolumnach -->
            <div class="row mt-4">
              <!-- Lewa kolumna - suwaki -->
              <div class="col-6">
                <div class="mb-4">
                  <button class="btn btn-warning w-100 mb-2" style="background-color: #FDD835; border-color: #FDD835; color: #000;">
                    Wybierz cenę
                  </button>
                  <div class="text-center mb-2" style="font-size: 0.85rem; margin-top: 8px;">
                    {{ numberWithSpaces(price[0]) }} - {{ numberWithSpaces(price[1]) }}
                  </div>
                  <div class="px-3">
                    <vue-range-slider v-model="price"
                      @input="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" 
                      :min="minPrice" :max="maxPrice" :step="10000">
                    </vue-range-slider>
                  </div>
                </div>
                
                <div class="mb-4" style="margin-top: 50px;">
                  <button class="btn btn-warning w-100 mb-2" style="background-color: #FDD835; border-color: #FDD835; color: #000;">
                    Wybierz powierzchnię
                  </button>
                  <div class="text-center mb-2" style="font-size: 0.85rem; margin-top: 8px;">
                    {{ area[0] }} - {{ area[1] }}
                  </div>
                  <div class="px-3">
                    <vue-range-slider v-model="area"
                      @input="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" 
                      :min="minArea" :max="maxArea" :step="5">
                    </vue-range-slider>
                  </div>
                </div>
              </div>
              
              <!-- Prawa kolumna - checkboxy i prospekt -->
              <div class="col-6">
                <div class="mb-4">
                  <button class="btn btn-warning w-100 mb-2" style="background-color: #FDD835; border-color: #FDD835; color: #000;">
                    Wybierz liczbę pokoi
                  </button>
                  <div class="d-flex justify-content-center gap-2 mt-2">
                    <label class="btn btn-warning btn-sm" 
                           :class="{ active: selectedRooms.includes(4) }"
                           style="background-color: #FDD835; border-color: #FDD835; color: #000;">
                      <input type="checkbox" v-model="selectedRooms" :value="4" 
                             @change="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" 
                             style="display: none;">
                      4
                    </label>
                    <label class="btn btn-warning btn-sm" 
                           :class="{ active: selectedRooms.includes(5) }"
                           style="background-color: #FDD835; border-color: #FDD835; color: #000;">
                      <input type="checkbox" v-model="selectedRooms" :value="5" 
                             @change="filterdTable(price, selectedRooms, area, isAvailable, checkedTypes)" 
                             style="display: none;">
                      5
                    </label>
                  </div>
                </div>
                
                <div class="mb-4">
                  <a href="/prospekty" target="_blank" rel="noopener"
                     class="btn btn-warning w-100" 
                     style="background-color: #FDD835; border-color: #FDD835; color: #000;">
                    Prospekt informacyjny
                  </a>
                </div>
              </div>
            </div>
            
            <button class="btn btn-outline-dark w-100 mt-3" @click="showMobileFilters = false">
              <span v-if="sortedFlats.length === 0" style="color:red;">Brak lokali spełniających kryteria</span>
              <span v-else>Pokaż wyniki ({{ sortedFlats.length }}) </span>
            </button>
          </div>
        </div>
      </div>


      <!-- Karty mieszkań - nowy układ -->
      <div class="mobile-flat-card mx-3 p-3 mb-3" v-for="item in sortedFlats" :key="item.id">
        
        <!-- Nagłówek z numerem i statusem -->
        <div class="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 class="mb-0" style="font-weight: bold;">{{ item.local_number }}</h5>
            <div v-if="item.stage && item.stage !== '' && !Array.isArray(item.stage)" 
                 style="font-size: 0.85em; color: #666; font-style: italic;">
              ({{ item.stage }})
            </div>
          </div>
          <div>
            <span v-if="item.status_name == 'Dostępne' && item.promotion == 0" 
                  style="color: #4CAF50; font-weight: bold;">
              {{ item.status_name }}
            </span>
            <span v-if="item.promotion == 1 && isPromotionActive(item) && item.status_name == 'Dostępne'"
                  style="font-weight: bold; color: #4CAF50;">
              Promocja
            </span>
            <span v-if="item.promotion == 1 && !isPromotionActive(item) && item.status_name == 'Dostępne'"
                  style="color: #4CAF50; font-weight: bold;">
              Dostępne
            </span>
            <span v-if="item.status_name == 'Rezerwacja ustna' || item.status_name == 'Umowa rezerwacyjna'"
                  style="color: orange; font-weight: bold;">
              Rezerwacja
            </span>
            <span v-if="item.status_name == 'Umowa końcowa' || item.status_name == 'Umowa deweloperska' || item.status_name == 'Umowa przedwstępna'"
                  style="color: red; font-weight: bold;">
              Sprzedany
            </span>
          </div>
        </div>

        <!-- Podstawowe informacje -->
        <div class="mb-2 d-flex justify-content-between">
          <span style="color: #666;">Powierzchnia użytkowa:</span> 
          <strong>
            <span v-if="(item.area && item.area > 0) || (item.area_usable && item.area_usable > 0)">
              {{ item.area && item.area > 0 ? item.area : item.area_usable }} m<sup>2</sup>
            </span>
            <span v-else>-</span>
          </strong>
        </div>

        <div class="mb-2 d-flex justify-content-between">
          <span style="color: #666;">Liczba pokoi:</span> 
          <strong>{{ item.rooms }}</strong>
        </div>

        <div class="mb-2 d-flex justify-content-between">
          <span style="color: #666;">Cena za m² (pow. użytkowa):</span> 
          <strong>
            <span v-if="item.promotion == 1 && isPromotionActive(item)">
              {{ numberWithSpaces(item.promotion_price_mkw) }} zł
              <span style="text-decoration: line-through; font-size: 0.85em; font-weight: 300;">
                {{ numberWithSpaces(item.pricemkw) }} zł
              </span>
            </span>
            <span v-else>
              {{ numberWithSpaces(item.pricemkw) }} zł
            </span>
          </strong>
        </div>

        <div class="mb-3 d-flex justify-content-between" v-if="item.ogrod">
          <span style="color: #666;">Ogród:</span> 
          <strong>{{ item.ogrod }} m<sup>2</sup></strong>
        </div>

        <!-- Cena nieruchomości - większa i pogrubiona -->
        <div class="mb-3 d-flex justify-content-between">
          <span style="color: #666;">Cena nieruchomości:</span> 
          <strong style="font-size: 1.05rem;">
            <span v-if="item.promotion == 1 && isPromotionActive(item)">
              {{ numberWithSpaces(item.promotion_price) }} zł
              <br>
              <span style="text-decoration: line-through; font-size: 0.8em; font-weight: 300;">
                {{ numberWithSpaces(item.price) }} zł
              </span>
            </span>
            <span v-else>
              {{ numberWithSpaces(item.price) }} zł
            </span>
          </strong>
        </div>

        <!-- Ikony 2D/3D -->
        <div class="d-flex gap-2 mb-3">
          <!-- Rzut -->
          <a v-if="item.document_link" :href="item.document_link" target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
            <img src="@/assets/plan.png" width="20" height="20" alt="2D">
            2D
          </a>
          <!-- Rzut 3D parter -->
          <a v-if="item.plan3d_link && (typeof item.plan3d_link === 'string' || (Array.isArray(item.plan3d_link) && item.plan3d_link.length > 0))"
             :href="item.plan3d_link.length === 1 ? item.plan3d_link[0] : item.plan3d_link[1]" 
             target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
            <img src="@/assets/3d.png" width="20" height="20" alt="3D parter">
            3D parter
          </a>
          <!-- Rzut 3D piętro - tylko gdy są 2 elementy -->
          <a v-if="Array.isArray(item.plan3d_link) && item.plan3d_link.length === 2"
             :href="item.plan3d_link[0]" 
             target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
            <img src="@/assets/3d.png" width="20" height="20" alt="3D piętro">
            3D piętro
          </a>
          <a v-if="item.view360 && item.view360.length > 0" :href="item.view360" target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
            3D
          </a>
        </div>

        <!-- Przyciski akcji -->
        <div class="d-flex gap-2 mb-2">
          <button class="btn btn-danger flex-grow-1" @click.prevent="showModal(item.local_number)"
                  style="background-color: #E57373; border-color: #E57373;">
            Zapytaj o rabat
          </button>
          <button class="btn btn-warning flex-grow-1" @click="toggleRow(item.id)"
                  style="background-color: #FDD835; border-color: #FDD835; color: #000;">
            {{ expandedRows.includes(item.id) ? "Zwiń" : "Zobacz więcej" }}
          </button>
        </div>

        <!-- Rozwinięta sekcja "Zobacz więcej" -->
        <div v-if="expandedRows.includes(item.id)" class="mt-3 pt-3" style="border-top: 1px solid #ddd;">
          <div class="mb-2 d-flex justify-content-between">
            <span style="color: #666;">Powierzchnia sprzedażowa:</span> 
            <strong>{{ item.area_usable }} m<sup>2</sup></strong>
          </div>

          <div class="mb-2 d-flex justify-content-between" v-if="item.pricemkw_usable">
            <span style="color: #666;">Cena za m² (pow. sprzedażowa):</span> 
            <strong>{{ numberWithSpaces(item.pricemkw_usable) }} zł</strong>
          </div>

          <div class="mb-2 d-flex justify-content-between" v-if="item.parking_places_in_price">
            <span style="color: #666;">Miejsca postojowe w cenie:</span> 
            <strong>{{ item.parking_places_in_price }}</strong>
          </div>

          <div class="mb-2">
            <span style="color: #666;">Cena zawiera:</span>
            <div class="mt-1">
              <contiguity-list-simple :item="item" />
            </div>
          </div>

          <div class="mb-2 d-flex justify-content-between" v-if="item.balkon && item.balkon > 0">
            <span style="color: #666;">Balkon:</span> 
            <strong>{{ item.balkon }} m<sup>2</sup></strong>
          </div>

          <div class="mb-2 d-flex justify-content-between" v-if="item.taras && item.taras > 0">
            <span style="color: #666;">Taras:</span> 
            <strong>{{ item.taras }} m<sup>2</sup></strong>
          </div>

          <div class="mb-2 d-flex justify-content-between" v-if="item.loggia && item.loggia > 0">
            <span style="color: #666;">Loggia:</span> 
            <strong>{{ item.loggia }} m<sup>2</sup></strong>
          </div>

          <div class="mb-3 d-flex justify-content-between" v-if="item.poddasze_nieuz && item.poddasze_nieuz > 0">
            <span style="color: #666;">Poddasze nieużytkowe:</span> 
            <strong>{{ item.poddasze_nieuz}} m<sup>2</sup></strong>
          </div>

          <div class="mb-2">
            <strong>Prawa niezbędne do korzystania z lokalu:</strong>
          </div>

          <div class="mb-3" v-if="item.monetary_benefits">
            <strong>Inne świadczenia pieniężne:</strong>
            <div class="mt-1" style="font-size: 0.9em; color: #666;">
              Koszty utrzymania Lokalu - od dnia przekazania Lokalu.
            </div>
            <div v-html="item.monetary_benefits" style="font-size: 0.85em;"></div>
          </div>

          <div v-if="pluginSettings.additional_field" class="mb-3">
            <strong>Dodatkowe informacje:</strong>
            <div v-html="pluginSettings.additional_field" style="font-size: 0.9em; color: #666;"></div>
          </div>

          <div class="mt-3">
            <price-history :flat-id="item.id" />
          </div>

          <p style="font-size: 0.85em; color: #666; margin-top: 1rem;">
            Wszystkie podane ceny są cenami brutto.
          </p>
        </div>

      </div>
    </div>

    <!-- Koniec wersji mobilnej -->
    <contact-form :flat="flat"></contact-form>
  </div>
</template>

<script>
import axios from "axios";
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";
import ContactForm from "./components/ContactForm";
import TooltipModal from "./components/TooltipModal.vue";
import PriceHistory from "./components/PriceHistory.vue";
// import ContiguityList from "./components/ContiguityList.vue";
import ContiguityListSimple from "./components/ContiguityListSimple.vue";

export default {
  name: "App",
  data() {
    return {
      url: window.location.origin,
      // url: "https://osiedleroztocze.pl",-> do testów lokalnych
      dataUrl: this.url + "/wp-json/twoqbs/v1/flats?nocache=1",
      singleFlatUrl: this.url + "/wp-json/twoqbs/v1/flat?nocache=1",
      tableFlats: [],
      flats: [],
      investmentInfo: [],
      pluginSettings: [],
      mainColor: "#63b0bd",
      //--Filtrowanie.
      minPrice: 0,
      maxPrice: 0,
      price: [this.minPrice, this.maxPrice],
      minArea: 0,
      maxArea: 0,
      area: [this.minArea, this.maxArea],
      minRooms: 0,
      maxRooms: 0,
      rooms: [this.minRooms, this.maxRooms],
      selectedRooms: [], // nowa zmienna dla checkboxów pokoi
      isAvailable: false,
      flat: {},
      showTypeFilters: false,
      currentSort: 'name',
      currentSortDir: 'asc',
      checkedTypes: [],
      typeOf: [],
      today: new Date().toISOString().split('T')[0],
      sortKey: '',       // aktualna kolumna sortowania
      sortAsc: true,     // kierunek sortowania: true = rosnąco
      expandedRows: [],  // rozwijana wiersz
      // selectedFlats: [], // tu będą ID zaznaczonych mieszkań
      showMobileFilters: false,

    };
  },
  components: {
    VueRangeSlider,
    "contact-form": ContactForm,
    "tooltip-modal": TooltipModal,
    "price-history": PriceHistory,
    // "contiguity-list": ContiguityList,
    "contiguity-list-simple": ContiguityListSimple
  },
  methods: {

    toggleRow(id) {
      if (this.expandedRows.includes(id)) {
        this.expandedRows = this.expandedRows.filter(rowId => rowId !== id);
      } else {
        this.expandedRows.push(id);
      }
    },

    sortBy(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc; // zmiana kierunku
      } else {
        this.sortKey = key;
        this.sortAsc = true; // domyślnie rosnąco
      }
    },
    isPromotionActive(item) {
      // Pomocnicza funkcja sprawdzająca czy data jest pusta
      const isEmpty = (dateStr) => {
        return !dateStr || dateStr === "" || dateStr === null || dateStr === undefined;
      };

      const today = new Date();
      today.setHours(0, 0, 0, 0); // zerujemy godziny dla czystego porównania dat

      const dateFrom = item.promotion_date_from ? new Date(item.promotion_date_from) : null;
      const dateTo = item.promotion_date_to ? new Date(item.promotion_date_to) : null;

      if (dateFrom) dateFrom.setHours(0, 0, 0, 0);
      if (dateTo) dateTo.setHours(0, 0, 0, 0);

      // Scenariusz 1: Promocja bez dat - zawsze aktywna
      if (isEmpty(dateFrom) && isEmpty(dateTo)) {
        console.log('SCENARIUSZ 1: Promocja bezterminowa - AKTYWNA');
        return true;
      }
      
      // Scenariusz 2: Tylko data "do" (bez daty "od") - aktywna do daty "do"
      if (isEmpty(dateFrom) && !isEmpty(dateTo)) {
        return today <= dateTo;
      }
      
      // Scenariusz 3: Tylko data "od" (bez daty "do") - aktywna od daty "od" w nieskończoność
      if (!isEmpty(dateFrom) && isEmpty(dateTo)) {
        return dateFrom <= today;
      }
      
      // Scenariusz 4: Obie daty ustawione - klasyczny przedział
      if (!isEmpty(dateFrom) && !isEmpty(dateTo)) {
        return dateFrom <= today && today <= dateTo;
      }
      
      // Fallback - jeśli coś poszło nie tak
      return false;
    },
    numberWithSpaces(price) {
      if (price === null || price === undefined || price === "") return "";
      // Zamień na liczbę, zaokrąglij do 2 miejsc po przecinku jeśli jest float
      const num = Number(price);
      if (isNaN(num)) return price;
      // Jeśli liczba jest całkowita
      if (Number.isInteger(num)) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      // Jeśli liczba jest zmiennoprzecinkowa
      const parts = num.toFixed(2).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(",");
    },
    test() {
      console.log(this.isAvailable);
    },

    compare(a, b) {
      // Priorytet 1: Typ lokalu - "Mieszkanie" na początku
      const isAFlat = a.type === "Mieszkanie";
      const isBFlat = b.type === "Mieszkanie";
      
      if (isAFlat && !isBFlat) return -1;  // a jest mieszkaniem, b nie - a pierwsze
      if (!isAFlat && isBFlat) return 1;   // b jest mieszkaniem, a nie - b pierwsze
      
      // Priorytet 2: Jeśli oba są tego samego typu (lub obie nie-mieszkania), sortuj po id
      if (a.id < b.id) return -1;
      if (a.id > b.id) return 1;
      
      return 0;
    },

    filterdTable(price, selectedRooms, area, available, checkedTypes) {
      this.tableFlats = [];
      this.flats.realestate.forEach((item) => {
        // obliczamy aktualną cenę (promocyjna albo zwykła)
        const itemPrice = item.promotion == 1 && this.isPromotionActive(item)
          ? item.promotion_price
          : item.price;
        const itemArea = (item.area && Number(item.area) > 0) ? Number(item.area) : Number(item.area_usable);
        // warunki wspólne
        const inRooms = selectedRooms.length === 0 ? true : selectedRooms.includes(Number(item.rooms));
        const inArea = itemArea >= area[0] && itemArea <= area[1];
        const inPrice = itemPrice >= price[0] && itemPrice <= price[1];
        const inStage = checkedTypes.length !== 0 ? checkedTypes.includes(item.type) : true;

        if (available) {
          if (
            inRooms &&
            inArea &&
            inPrice &&
            item.status_name === "Dostępne" &&
            inStage
          ) {
            if (item.dont_send_to_www == 0) {
              console.log(this.item)
              this.tableFlats.push(item);
            }
          }
        } else {
          if (
            inRooms &&
            inArea &&
            inPrice &&
            inStage
          ) {
            if (item.dont_send_to_www == 0 && item.status_id != 9) {
              this.tableFlats.push(item);
            }
          }
        }
      });

      // sortowanie na końcu (raz, a nie w każdej iteracji)
      this.tableFlats.sort(this.compare);
    }
    ,
    showModal(flatName) { 
      this.$modal.show('contact-form', { flat: flatName });
      this.flat = flatName;
      // Blokuj scrollowanie tła
      document.body.style.overflow = 'hidden';
      this.$root.$emit('modal:opened');
    },
    getTypesOf(flats) {
  flats.forEach((item) => {
    if (!this.typeOf.includes(item.type)) {
      this.typeOf.push(item.type)
    }
  })
  this.typeOf.sort((a, b) => a.localeCompare(b));
  // Przesuń "Mieszkanie" na początek, jeśli istnieje
  const idx = this.typeOf.indexOf("Mieszkanie");
  if (idx > 0) {
    this.typeOf.splice(idx, 1);
    this.typeOf.unshift("Mieszkanie");
  }
  return this.typeOf
},

    getPriceRange(flats) {
      this.price = []; // reset tablicy

      flats.forEach((item) => {
        // Użyj tej samej logiki co w filterdTable - sprawdź czy promocja aktywna
        let priceToUse = item.price;
        
        // Sprawdź czy promocja jest aktywna
        if (item.promotion == 1 && item.promotion_price && Number(item.promotion_price) > 0 && 
            item.promotion_price_mkw && Number(item.promotion_price_mkw) > 0) {
          priceToUse = item.promotion_price;
        }
        
        const value = parseInt(priceToUse);
        if (!isNaN(value) && value > 0) {
          this.price.push(value);
        }
      });
      
      const cenyBezZera = this.price.filter(v => v > 0);
      if (cenyBezZera.length > 0) {
        const min = Math.min(...cenyBezZera);
        const max = Math.max(...cenyBezZera);
        this.minPrice = Math.floor(min / 10000) * 10000; // zaokrąglamy w dół
        console.log(this.minPrice)
        this.maxPrice = Math.ceil(max / 10000) * 10000;  // zaokrąglamy w górę
        this.price = [];
        this.price.push(this.minPrice);
        this.price.push(this.maxPrice)
      } else {
        this.minPrice = 0;
        this.maxPrice = 10000000;
        this.price = [];
        this.price.push(this.minPrice);
        this.price.push(this.maxPrice)
      }
    },
    getRoomsRange(flats) {
      this.rooms = []; // reset tablicy

      flats.forEach((item) => {
        const value = parseInt(item.rooms);

        if (!isNaN(value) && value > 0) {
          // tylko poprawne liczby > 0
          this.rooms.push(value);
        } else {
          // console.log("rooms pominąłem:", item.rooms);
        }
      });

      if (this.rooms.length > 0) {
        this.minRooms = Math.min(...this.rooms);
        this.maxRooms = Math.max(...this.rooms);
        this.minRooms = 0;
        this.rooms = []
        this.rooms.push(this.minRooms)
        this.rooms.push(this.maxRooms)
      } else {
        this.minRooms = 0;
        this.maxRooms = 10;
        this.rooms = []
        this.rooms.push(this.minRooms)
        this.rooms.push(this.maxRooms)
      }
    },
    getAreaRange(flats) {
      this.area = []; // reset tablicy

      flats.forEach((item) => {
        const value = parseInt(item.area);

        if (!isNaN(value) && value > 0) {
          // tylko poprawne liczby > 0
          this.area.push(value);
        } else {
          // console.log("area usable pominąłem:", item.area_usable);
        }
      });

      if (this.area.length > 0) {
        const min = Math.min(...this.area);
        const max = Math.max(...this.area);
        this.minArea = Math.floor(min / 10) * 10; // zaokrąglamy w dół
        this.maxArea = Math.ceil(max / 10) * 10;  // zaokrąglamy w górę
        this.area = [];
        this.area.push(this.minArea)
        this.area.push(this.maxArea)
      } else {
        this.minArea = 0;
        this.maxArea = 500;
        this.area = [];
        this.area.push(this.minArea)
        this.area.push(this.maxArea)
      }
    },
    hasAdditionalAreas(item) {
      return (
      (item.balkon && String(item.balkon).trim() !== "" && item.balkon !== "0") ||
      (item.taras && String(item.taras).trim() !== "" && item.taras !== "0") ||
      (item.loggia && String(item.loggia).trim() !== "" && item.loggia !== "0") ||
      (item.ogrod && String(item.ogrod).trim() !== "" && item.ogrod !== "0") ||
      (item.contiguity_list?.contiguity?.length > 0)
      );
    },

    getProspectLink(stage) {
      if (!this.pluginSettings) return null;
      let key;
      if (!stage || !String(stage).trim()) {
        key = 'prospect_brak-etapu';
      } else {
        key = 'prospect_' + this.sanitizeTitle(stage);
      }
      return this.pluginSettings[key] || null;
    },
    sanitizeTitle(str) {
      return String(str)
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-_]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
    }



  },

  computed: {
    sortedFlats() {
      const sorted = [...this.tableFlats]; // nie mutujemy oryginału
      // console.log(sorted)
      if (this.sortKey === 'price') {
        sorted.sort((a, b) => {
          const aPrice = a.promotion === 1 && this.isPromotionActive(a) ? a.promotion_price : a.price;
          const bPrice = b.promotion === 1 && this.isPromotionActive(b) ? b.promotion_price : b.price;
          return this.sortAsc ? aPrice - bPrice : bPrice - aPrice;
        });
      } else if (this.sortKey === 'rooms') {
        sorted.sort((a, b) => {
          return this.sortAsc
            ? Number(a.rooms) - Number(b.rooms)
            : Number(b.rooms) - Number(a.rooms);
        });
      } else if (this.sortKey === 'area') {
        sorted.sort((a, b) => {
          const areaA = a.area_usable && a.area_usable > 0 ? Number(a.area_usable) : Number(a.area);
          const areaB = b.area_usable && b.area_usable > 0 ? Number(b.area_usable) : Number(b.area);
          return this.sortAsc
            ? areaA - areaB
            : areaB - areaA;
        });
      }

      return sorted;
    },





  },

  watch: {
    showMobileFilters(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none'; // dla lepszej blokady na mobile
      } else {
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
      }
    }
  },


  mounted() {
    const autoUrl = window.location.origin + "/wp-json/twoqbs/v1/flats?nocache=" + new Date().getTime()
    const autoUrlSettings = window.location.origin + "/wp-json/twoqbs/v1/settings?nocache=" + new Date().getTime()
    const autoUrlInvestment = window.location.origin + "/wp-json/twoqbs/v1/investment?nocache=" + new Date().getTime()

    // const autoUrl = "https://waw.re/wp-json/twoqbs/v1/flats?nocache=" + new Date().getTime()  //-> do testów lokalnych
    // const autoUrlSettings = "https://waw.re/wp-json/twoqbs/v1/settings?nocache=" + new Date().getTime() // -> do testów lokalnych
    // const autoUrlInvestment = "https://waw.re/wp-json/twoqbs/v1/investment?nocache=" + new Date().getTime() // -> do testów lokalnych


    // const autoUrl = "https://test.2qbs.pl/wp-json/twoqbs/v1/flats?nocache=" + new Date().getTime()  //-> do testów lokalnych
    // const autoUrlSettings = "https://test.2qbs.pl/wp-json/twoqbs/v1/settings?nocache=" + new Date().getTime() // -> do testów lokalnych
    // const autoUrlInvestment = "https://test.2qbs.pl/wp-json/twoqbs/v1/investment?nocache=" + new Date().getTime() // -> do testów lokalnych
    axios.get(autoUrl).then((response) => {
      this.flats = response.data;
      this.tableFlats = this.flats.realestate;
      // console.log(this.tableFlats)
      this.tableFlats.sort(this.compare);
      this.getTypesOf(this.tableFlats)
      this.getPriceRange(this.tableFlats)
      this.getRoomsRange(this.tableFlats)
      this.getAreaRange(this.tableFlats)
      this.filterdTable(this.price, this.selectedRooms, this.area, this.isAvailable, this.checkedTypes)

    });

    axios.get(autoUrlSettings).then((response) => {
      this.pluginSettings = response.data;
      this.mainColor = this.pluginSettings.main_color || '#63b0bd';
      this.setSliderBackground();
      // console.log(this.pluginSettings)
    });

    axios.get(autoUrlInvestment).then((response) => {
      this.investmentInfo = response.data;
      // console.log(this.investment)
    });

    axios.post(this.restUrl, this.contactForm).then((response) => {
      console.log(response);

    });

    // Przywróć scrollowanie gdy modal zostanie zamknięty
    this.$modal.$on('hidden', () => {
      document.body.style.overflow = '';
      this.$root.$emit('modal:closed');
    });

    this.$modal.$on('closed', () => {
      document.body.style.overflow = '';
      this.$root.$emit('modal:closed');
    });
  },
};
</script>

<style >
#app {
  font-family: "Encode Sans", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  display: block;

}


.simple-range-slider {
  bottom: -30px;
  background: none;
  box-shadow: none;
}

.modal {
  position: absolute;
  width: 500px;
  height: 500px;
  background-color: red;
}

.toggle-button {
  padding: 8px 12px;
  border: 1px solid #ccc;
  cursor: pointer;
  background: #f8f8f8;
  margin-bottom: 8px;
}

.twoqbsTypeCheckboxList {
  /* border: 1px solid #ddd; */
  padding: 10px;
  max-height: 200px;
  overflow-y: auto;
  background: white;
}





.vue-range-slider.slider-component .slider .slider-process {
  background-color: var(--main-color, #000000);
}

.vue-range-slider.slider-component {
  display: inline-block;
}

.vue-range-slider.slider-component .slider-tooltip-wrap .slider-tooltip {
  background-color: var(--main-color, #000000);
  border: 1px solid var(--main-color, #000000);
  color: #455359 !important;
  padding: 5px 25px;
  border-radius: 25px
}

.btn-outline-dark {
  --bs-btn-hover-bg: var(--main-color, #000000) !important;
}

/* Specjalne style dla przycisków sortowania */
.twoqbsStageButton {
  background-color: var(--main-color, #000000) !important;
  border-color: var(--main-color, #000000) !important;
  color: #455359 !important;
}

.twoqbsStageButton:hover {
  background-color: var(--main-color, #000000) !important;
  border-color: var(--main-color, #000000) !important;
  color: #455359 !important;
  opacity: 0.9;
}

.twoqbsWawreButton {
  background-color: #e6736c !important;
  border-color: #e6736c !important;
  color: #ffffff !important;

}

/* Styl panelu mobilnych filtrów */
.mobile-filters-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
}

.mobile-filters-panel {
  background: #fff;
  width: 100%;
  border-radius: 16px 16px 0 0;
  padding: 24px 16px 16px 16px;
  max-height: 95vh;
  overflow-y: auto;
  position: relative;
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 16px;
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  color: #333;
}

@media (min-width: 768px) {
  .mobile-filters-overlay {
    display: none !important;
  }
}

@import "./assets/vue-range-slider.css";
@import "./assets/bootstrap.min.css";

.vm--modal input,
.vm--modal textarea {
  background-color: #ffffff;
  border-color: #e1e1e1;
  border-width: 0px 0px 1px 0px;
  border-radius: 0px 0px 0px 0px;
}

.vm--modal input,
.vm--modal textarea:focus {
  outline: none;
  border: 1px solid #e1e1e1;
  border-radius: 1px;
}

.vm--modal .form-check-label {
  font-size: 12px;
  text-align: left;
}

.vm--modal {
  height: auto !important;
}

.vm--container {
  overflow: auto;
}

.button-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.button-stack .btn {
  width: 100%;
  margin: 0;
}

.button-stack .btn-sm {
  width: 70%;
  font-size: calc(0.875rem - 3px);
  align-self: center;
}

.twoqbsxml-td {
  vertical-align: middle;
}

.twoqbsxml-th, th {
  vertical-align: middle;
  font-size:0.9rem;
  white-space: word-wrap;
  text-align: center;
}

.room-checkboxes .btn {
  transition: all 0.3s ease;
}

.room-checkboxes .btn.active {
  background-color: var(--main-color, #000000) !important;
  border-color: var(--main-color, #000000) !important;
  color: #455359 !important;
}

.room-checkboxes .btn:hover {
  background-color: var(--main-color, #000000) !important;
  border-color: var(--main-color, #000000) !important;
  color: #455359 !important;
}

/* Style dla wersji mobilnej */
@media (max-width: 767px) {
  .d-block.d-sm-block.d-md-none .border {
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .d-block.d-sm-block.d-md-none .btn-outline-dark {
    font-size: 0.85rem;
  }
}

/* Karty mieszkań - nowy układ mobilny */
.mobile-flat-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  text-align: left;
}

.mobile-flat-card h5 {
  font-size: 1.25rem;
  color: #000;
}

.mobile-flat-card .btn-danger {
  font-weight: 500;
}

.mobile-flat-card .btn-warning {
  font-weight: 500;
}

/* Żółte przyciski filtrów mobilnych */
.mobile-filters-panel .btn-warning.active {
  opacity: 0.8;
}
</style>

